module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-menu"
  }, [_c('div', {
    staticClass: "select-menu__options"
  }, _vm._l((_vm.dico.config), function(farm, index) {
    return (farm.id) ? _c('router-link', {
      key: index,
      staticClass: "select-menu__option",
      class: {
        selected: farm.id == _vm.currentFarm.config.id
      },
      attrs: {
        "to": farm.id
      }
    }, [_c('div', {
      staticClass: "select-menu__option-portrait",
      style: ({
        backgroundImage: 'url(' + _vm.getFarmPortrait(farm.infos.portrait_image) + ')'
      })
    }), _c('div', {
      staticClass: "select-menu__option-text"
    }, [_vm._v(_vm._s(farm.infos.farmer_name) + " - " + _vm._s(farm.location.label))])]) : _vm._e()
  })), _c('div', {
    staticClass: "select-menu__item"
  }, [_c('div', {
    staticClass: "select-menu__left"
  }, [_c('div', {
    staticClass: "select-menu__item-portrait",
    style: ({
      backgroundImage: 'url(' + _vm.currentPortrait + ')'
    })
  })]), _c('div', {
    staticClass: "select-menu__right"
  }, [_c('div', {
    staticClass: "select-menu__item-title"
  }, [_vm._v(_vm._s(_vm.currentFarm.config.infos.farmer_name))]), _c('div', {
    staticClass: "select-menu__item-location"
  }, [_vm._v(_vm._s(_vm.currentFarm.config.infos.label) + " - " + _vm._s(_vm.currentFarm.config.location.label))]), _c('div', {
    staticClass: "select-menu__item-description",
    domProps: {
      "innerHTML": _vm._s(_vm.currentFarm.dico.intro_farmer)
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-83d449e6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83d449e6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/select-menu/SelectMenuComponent.vue
// module id = 829
// module chunks = 0